import { api } from './api';

export interface AuditEntry {
  id: string;
  company_id: string;
  workspace_id: string | null;
  user_id: string | null;
  action: string;
  target_kind: string | null;
  target_id: string | null;
  payload: Record<string, unknown> | null;
  ip: string | null;
  created_at: string;
}

export interface AuditQuery {
  limit?: number;
  offset?: number;
  since?: string; // ISO timestamp
  action?: string;
  actor?: string;
  q?: string;
}

export const auditLogApi = {
  async list(companyId: string, query: AuditQuery = {}): Promise<AuditEntry[]> {
    const r = await api.get<AuditEntry[]>(
      `/api/companies/${companyId}/audit-log`,
      { params: { limit: 100, ...query } },
    );
    return r.data;
  },
};
